// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
const winston = require('winston');

const logger = winston.createLogger({
  format: winston.format.combine(
    winston.format.timestamp(),
    winston.format.printf(({ timestamp, level, message }) => {
      return `[${timestamp}] [${level}] [${message}]`;
    })
  ),
  transports: [
    new winston.transports.Console(), // Use Console transport for logging to the console
  ],
});

function error(errorText, timestamp) {
  logger.error(`[${timestamp}] ${errorText}`);
}

module.exports = {
  error,
};


// TO DO. LET IT CREATING LOGGIN FILES

/*
const winston = require('winston');
const RNFS = require('react-native-fs');

// Define the log directory and file names
const logDirectory = RNFS.DocumentDirectoryPath;
const errorLogFileName = 'error.log';
const warningLogFileName = 'warning.log';
const infoLogFileName = 'info.log';

// Create log files (if they don't exist)
const createLogFiles = async () => {
  try {
    await RNFS.mkdir(logDirectory);
    await RNFS.writeFile(`${logDirectory}/${errorLogFileName}`, '', 'utf8');
    await RNFS.writeFile(`${logDirectory}/${warningLogFileName}`, '', 'utf8');
    await RNFS.writeFile(`${logDirectory}/${infoLogFileName}`, '', 'utf8');
  } catch (error) {
    console.error('Error creating log files:', error);
  }
};

// Call the function to create log files
createLogFiles();

const logger = winston.createLogger({
  format: winston.format.combine(
    winston.format.timestamp(),
    winston.format.printf(({ timestamp, level, message, meta }) => {
      return `[${timestamp}] [${level}] [${meta.category}]: ${message}`;
    })
  ),
  transports: [
    new winston.transports.File({ filename: `${logDirectory}/${errorLogFileName}`, level: 'error' }),
    new winston.transports.File({ filename: `${logDirectory}/${warningLogFileName}`, level: 'warn' }),
    new winston.transports.File({ filename: `${logDirectory}/${infoLogFileName}`, level: 'info' }),
  ],
});

module.exports = logger;
*/
